import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeletePlatformCustomCoversMutation } from "../graphql/mutations";
import type {
  DeletePlatformCustomCoversMutationType,
  DeletePlatformCustomCoversMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeletePlatformCustomCoversMutation = (
  options?: MutationHookOptions<
    DeletePlatformCustomCoversMutationType,
    DeletePlatformCustomCoversMutationVariablesType
  >
) => {
  return useMutation<
    DeletePlatformCustomCoversMutationType,
    DeletePlatformCustomCoversMutationVariablesType
  >(DeletePlatformCustomCoversMutation, options);
};
